import { endpoints } from "@/configs/Settings";
import { HTTPResponseStatus } from "@/utils/enum";
import { useAuth } from "@/utils/useAuth";
import { useAxios } from "@/utils/useAxios";

export async function ValidateTiss(xml: string) {
  const url = `${endpoints.TISS}/validate`;
  const data = xml;
  const headers = {
    Accept: "application/json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/xml",
  };

  const response = await useAxios
    .post(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`Validate Tiss: ${response.status}`);
      }
      return { data: response.data, status: response.status };
    })
    .catch((error) => {
      console.error("Validate Tiss ", error);
      // toast.error(`EditAppointment Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
